export default function getTagDefinitions(): string[] {
  return [];
}

export type TagPair = [position: string, tag: string];
/**
 * WIP
 */
export const getPowerInformationTagDefinitions = (): TagPair[] => {
  return [
    ['01NDB10U901', 'av'],
    ['NDB10CU010',  'av'],
    ['NDB31CU001',  'av'],
    ['NDE11FU002',  'av'],
    ['NDE11FU001',  'av'],
    ['3NPU01',      'av'],
    ['5NDB20FN001', 'av'],
    ['10NPU01',     'av'],
    ['11ND20CU901', 'av'],
    ['17N20CU001',  'av'],
    ['00100WQ01VP', 'av'],
    ['LAOU01',      'av'],
    ['30N10CU001',  'av'],
    ['20NDA30CU001','av'],
    ['31NDB22CU001','av'],
  ]
}

export const getPressureDifferenceTagDefinitions = (): TagPair[] => {
  return [
    ['NDB10CP901', 'av'],
    ['CYG26CP901', 'av'],
    ['RAB12CP902', 'av'],
    ['RAB12CP901', 'av'],
    ['CYG29CP901', 'av'],
    ['UM10PD01',   'av'],
    ['CYG25CP901', 'av'],
    ['CYG28CP901', 'av'],
    ['CYG30CP901', 'av'],
    ['16PD901',    'av'],
    ['00100PE00P', 'av'],
    ['17N10CP901', 'av'],
    ['06DP001',    'av'],
    ['UM10PD0401', 'av'],
    ['05000PE01P', 'av'],
    ['05100PE01P', 'av'],
  ];
};
